<template>
  <div>
    <div class="input-group">
      <div class="input-group-prepend custom">
        <h4 class="mt-2">ظرفیت کل کارگاه ها</h4>
        <div class="input-group-text ml-3 h-100">
          <i class="icon-calendar-blank-outline"></i>
          <span>ظرفیت از امروز تا تاریخ </span>
        </div>
      </div>
      <date-picker
        v-show=true

        format="jYYYY-jMM-jDD"
        @input="setDateFromDatePicker"
        ref="datePicker"
      >
        <slot>
          <input
            :readonly=true
            v-model="endPlanningDateJ"
            class="form-control date-input"
            @click="toggleEndPlanningDatePicker"
          >
        </slot>
      </date-picker>
      <div class="input-group-text ml-3 h-100">
        <i class="icon-calendar-blank-outline"></i>
        <span> تعداد روز کاری :</span>
        <span class="mx-1">{{planning.totalDayCount}}</span>
        <span class="mx-1">روز</span>
      </div>
    </div>
    <hr/>
    <h4 class="mr-3">تعداد ساعات شیفتها</h4>
    <div class="col-12 text-center mt-3">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col" class="text-center">نام شیفت</th>
          <th scope="col" class="text-center">ظرفیت(ساعت)</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in planning.totalShifts">
          <!--<td class="text-center">-->
          <!--&lt;!&ndash;<button :id="'btn-delete-' + item.id" class="btn btn-secondary mx-2"&ndash;&gt;-->
          <!--&lt;!&ndash;:class="{'btn-danger': deleteButtonState === 'suspend'}" @click="onEditClicked(item, index)"><i&ndash;&gt;-->
          <!--&lt;!&ndash;class="icon-bd-pencil"></i></button>&ndash;&gt;-->
          <!--<button :id="'btn-delete-' + item.id" class="btn btn-secondary mx-2"-->
          <!--@click="onDeleteClicked(item)"><i-->
          <!--class="icon-bd-delete"></i></button>-->
          <!--</td>-->
          <th scope="row" class="text-center">{{item.name}}</th>
          <td class="text-center">{{item.unUsed}}</td>

        </tr>
        </tbody>
      </table>

      <!--<div class="col-12" v-if="showPagination">-->
      <!--<b-pagination size="md" v-model="pageIndex" :total-rows="rows" :per-page="pageSize" align="center"-->
      <!--@input="nextPage(pageIndex)"/>-->
      <!--</div>-->
    </div>
    <hr/>

    <h4 class="mr-3">ساعات استفاده شده کارگاه ها</h4>
    <div class="row">
      <!--<div class="col-lg-4 col-sm-6 my-5">-->
      <!--<div class="card shadow text-white  mb-1">-->
      <!--<div class="card-body pb-0">-->
      <!--<div class="card-chart">-->
      <!--<canvas id="polar-chart" width="400" height="400"></canvas>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <div class="col-lg-12 col-sm-12 my-2">
        <div class="card shadow text-white  mb-1">
          <div class="card-body pb-0">
            <div class="card-chart">
              <canvas id="bar-chart" width="1200" height="555"></canvas>
            </div>
          </div>
        </div>
      </div>

      <!--<div class="col-lg-12 col-sm-12 my-2">-->
      <!--<div class="card shadow text-white mb-1">-->
      <!--<div class="card-body pb-0">-->
      <!--<div class="card-chart">-->
      <!--<canvas id="area-chart" width="1600" height="500"></canvas>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
    </div>

    <div class="col-12 text-center mt-3">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col" class="text-center">نام کارگاه</th>
          <th scope="col" class="text-center">ظرفیت</th>
          <!--<th scope="col" class="text-center">ظرفیت کل</th>-->
          <!--<th scope="col" class="text-center">ظرفیت استفاده شده</th>-->
          <!--<th scope="col" class="text-center">ظرفیت باقیمانده</th>-->
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in planning.totalCompanyShifts">
          <!--<td class="text-center">-->
          <!--&lt;!&ndash;<button :id="'btn-delete-' + item.id" class="btn btn-secondary mx-2"&ndash;&gt;-->
          <!--&lt;!&ndash;:class="{'btn-danger': deleteButtonState === 'suspend'}" @click="onEditClicked(item, index)"><i&ndash;&gt;-->
          <!--&lt;!&ndash;class="icon-bd-pencil"></i></button>&ndash;&gt;-->
          <!--<button :id="'btn-delete-' + item.id" class="btn btn-secondary mx-2"-->
          <!--@click="onDeleteClicked(item)"><i-->
          <!--class="icon-bd-delete"></i></button>-->
          <!--</td>-->
          <th scope="row" class="text-center">{{item.name}}</th>
          <td class="text-center">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">نام شیفت</th>
                <th scope="col" class="text-center">ظرفیت استفاده شده(ساعت)</th>
                <th scope="col" class="text-center">ظرفیت باقیمانده(ساعت)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item2, index2) in planning.totalCompanyShifts[index].totalShifts">

                <td scope="row" class="text-center">{{item2.name}}</td>
                <td class="text-center">{{item2.used}}</td>
                <td class="text-center">{{item2.unUsed}}</td>

              </tr>
              </tbody>
            </table>
          </td>

        </tr>
        </tbody>
      </table>

      <!--<div class="col-12" v-if="showPagination">-->
      <!--<b-pagination size="md" v-model="pageIndex" :total-rows="rows" :per-page="pageSize" align="center"-->
      <!--@input="nextPage(pageIndex)"/>-->
      <!--</div>-->
    </div>


  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import ShowProblemsModal from "../../components/ShowProblemsModal";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState} from "vuex";
  import ProblemDetails from "../../components/ProblemDetails.vue";
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Utils from "../../_framework/utils/Utils";
  import Moment from "moment-jalali";
  import chart from "chart.js";


  export default {
    name: "totalcompanyplanning",
    components: {
      VsTable,
      datePicker: DatePicker,
      Moment,
    },
    data() {
      return {
        access: {},
        dateClicked: 0,
        todayDate: null,
        startDate: null,
        endDate: null,
        planning: {},
        endPlanningDateJ: null,
        endPlanningDate: null,
        myDate: null,

        companies: [],
        shifts: [],
        companyShifts: [],
        shiftsData: [],
        backgroundColor: [],
        borderColor: [],
      };
    },
    beforeMount() {
      this.backgroundColor = [];
      this.borderColor = [];
      this.backgroundColor.push('rgba(255,193,7,0.71)');
      this.borderColor.push('rgba(255,143,0,0.71)');


      this.backgroundColor.push('rgba(249,60,103,0.71)');
      this.borderColor.push('rgba(198,40,40,0.71)');

      this.backgroundColor.push('rgba(3,169,244,0.71)');
      this.borderColor.push('rgba(3,169,244,0.71)');

      this.backgroundColor.push('rgba(76,175,80,0.71)');
      this.borderColor.push('rgba(76,175,80,0.7)');

      this.backgroundColor.push('rgba(205,220,57,0.71)');
      this.borderColor.push('rgba(135,150,40,0.71)');

    },
    mounted() {
      this.myDate = Moment(new Date());
      this.myDate.add(30, 'days');
      this.myDate = this.myDate.toJSON().slice(0, 10);
      this.myDate = Moment(this.myDate, "YYYY-MM-DD");
      this.todayDate = this.myDate.format("jYYYY-jMM-jDD");


      this.endPlanningDate = this.todayDate;
      this.getPlanning(this.endPlanningDate);
      Chart.defaults.global.defaultFontFamily = 'shabnam';
    },
    methods: {


      toggleEndPlanningDatePicker() {
        this.dateClicked = 1;
        this.$refs.datePicker.togglePicker();
      },

      setDateFromDatePicker(date) {

        if (this.dateClicked === 1) {
          this.endPlanningDateJ = date;
          let date1 = Moment(this.endPlanningDateJ, "jYYYY/jMM/jDD");
          this.endPlanningDate = date1.format("YYYY-MM-DD");
          this.getPlanning(this.endPlanningDate);
        }
      },

      getPlanning(date) {
        let createTimesheet = {
          startDate: (this.todayDate),
          endDate: (date)
        };
        new BaseService('Planning', '/GetAllPlannings').create(createTimesheet).then((response) => {
            this.planning = response.data;
            this.companies = [];
            this.companyShifts = [];
            this.shifts = [];
            this.shiftsData = [];
            if (this.planning != null) {
              for (let item of this.planning.totalShifts) {
                var data = {
                  name: item.name,
                  used: item.unUsed,
                };
                this.shifts.push(data);
              }
              const mainCompany = "کل ساعات کار شرکت";
              this.companies.push(mainCompany);
              for (let item of this.planning.totalCompanyShifts) {
                this.companies.push(item.name);
              }

              let shIndex = 0;
              for (let mainShift of this.shifts) {

                this.companyShifts.push(mainShift.used);
                for (let comp of this.planning.totalCompanyShifts) {
                  let countt = 0;
                  for (let shift of comp.totalShifts) {
                    if (shift.name === mainShift.name) {
                      countt = shift.used;
                      break;
                    }
                  }
                  this.companyShifts.push(countt);
                }


                const data = {
                  label: mainShift.name,
                  data: this.companyShifts,
                  backgroundColor: this.backgroundColor[shIndex],
                  borderColor: this.borderColor[shIndex],

                };
                this.shiftsData.push(data);
                this.companyShifts = [];
                shIndex = shIndex + 1;
                if (shIndex > 4) {
                  shIndex = 0;
                }

              }
              var ctx = document.getElementById('bar-chart').getContext('2d');
              var myChart = new Chart(ctx, {
                type: 'bar',
                data: {
                  labels: this.companies,
                  datasets: this.shiftsData,
                }, options: {
                  scales: {
                    xAxes: [{
                      stacked: true
                    }],
                    yAxes: [{
                      stacked: true
                    }]
                  },
                  title: {
                    display: true,
                    text: 'ظرفیت ساعتهای کارگاه ها'
                  },
                }

              });

            }


          }
        ).catch((error) => {
          console.log(error)
        })
      },


    }
    ,
    created: () => {
    },

    computed:
      {
        ...
          mapState(["selectedRows", "currentService", "vsTableFeed"]),

      }
  }
  ;
</script>



